@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.onboard-container {
  --card-background-color: var(--white);
  --card-connected-color: var(--grey-600);

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: @space-24;
  width: 100%;
  background: var(--green-0C5B36);
  border-bottom: 1px solid var(--grey-300);
}

.onboard-column {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  padding: @space-0 @space-16;
  width: 100%;
}

.home-page-title {
  font-weight: 500;
  color: var(--white);
}

.onboard-cards {
  display: flex;
  flex-flow: row wrap;
  gap: @space-24;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.onboard-card-container {
  display: flex;
  flex-direction: row;
  gap: @space-16;
  flex: 0 1 392px;
  min-width: 200px;
}

.onboard-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 272px;
  border-radius: 8px;
  padding: @space-24;
  gap: @space-8;
  border: 1px solid var(--green-00331C);
  background: var(--white);

  &.popup-card {
    background: unset;
    border: unset;

    height: fit-content;
    padding: 0;
  }
}

.complete {
  background: var(--gray-FFF-A85);
}

.onboard-cards-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: var(--white);
  width: 100%;
}

.svg-and-percent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: @space-16;
  height: 48px;
  margin-bottom: @space-24;
}

.onboard-card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.percent-container {
  gap: @space-8;
  align-items: center;
  justify-content: center;
}
.onboard-svg {
  width: 24px;
  height: 24px;
}

.button-and-divider {
  gap: @space-8;
}

.divider {
  width: 1px;
  padding-left: 1px;
  border-left: 1px solid var(--grey-300);
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  &:hover {
    cursor: pointer;
    border-radius: 4px;
    background: var(--grey-300);
  }
}

.x-mark {
  width: 24px;
  height: 24px;
  color: var(--white);
  &:hover {
    color: var(--grey-800);
  }
}

.card-title {
  font-weight: 500;
}

.body-and-footer {
  justify-content: space-between;
  height: 100%;
}

.footer-row {
  justify-content: flex-start;
  align-items: center;
  flex-flow: nowrap;
  gap: @space-8;
}

.footer-row-group {
  width: calc((100% - 16px) / 2);
  text-align: center;
}

.additional-action-button {
  font-weight: 500;
  padding: @space-8 6px;
}

.connected-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 48px;
  max-height: 48px;
  min-width: 60px;
  padding: @space-12;
  border-radius: 50px;
  background-color: var(--white);
}

.popup-card {
  .link-button {
    color: var(--blue-400);
    &:hover,
    &:focus {
      color: var(--grey-300);
      background-color: var(--blue-300-fade-30);
    }
  }
  .connected-icon {
    background-color: var(--grey-000);
    border: 1px solid var(--grey-300);
  }
  .svg-and-percent {
    margin-bottom: 0;
  }
  .body-and-footer {
    gap: @space-16;
  }
}

.marketplace-icon {
  padding-left: 5px;
  height: 30px;
}

.order-imported-icon {
  color: var(--grey-600);
  height: 24px;
}

.provider-icon {
  height: 30px;
  width: 30px;
}

.location-icon {
  height: 24px;
  width: 18px;
  color: var(--grey-600);
}

.provider-text {
  font-size: 14px;
  width: 100%;
}

.date {
  display: flex;
  align-items: center;
}

.dot {
  width: 12px;
  height: 4px;
  padding: @space-0 @space-4;
}

.complete-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-8;
  padding: @space-12 @space-12 @space-12 @space-0;
  width: fit-content;
}

.arrow {
  width: 14px;
  height: 14px;
}

.manual-order-header {
  flex-wrap: nowrap;
  gap: @space-8;
  align-items: center;
  min-height: 48px;
  max-height: 48px;
  min-width: 60px;
  padding: @space-16;
  border-radius: 50px;
  background-color: var(--white);
  color: var(--grey-900);
}
